'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("inventaireDocumentTab", function () {
  return {
    label: "portefeuille.Documents",
    icon: "fa-file-text-o",
    fragment: "documents",
    controller: "InventaireDocumentTabController",
    template: require("./documents/documents.html")
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/inventaire/inventaireModuleFactory.js
// module id = 2830
// module chunks = 13